export default (entities) => ({
  createCharge(charge) {
    return entities.Charge.create(charge);
  },
});
